import { Checkbox } from 'antd';

import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';

import './BaseCheckboxGroup.scss';

const BaseCheckboxGroup_ = (props) => {
  const { field, onBlur, handleChange, customKeys, options, ...rest } = props;

  const mappedOptions = (options, keys = { label: 'name', value: 'id' }) => {
    return options.map((o) => ({
      label: o[keys.label],
      value: o[keys.value],
    }));
  };

  return (
    <Checkbox.Group
      {...field}
      {...rest}
      options={customKeys ? mappedOptions(options, customKeys) : mappedOptions(options)}
      onBlur={onBlur}
      onChange={handleChange}
    />
  );
};

export const BaseCheckboxGroup = BaseFormFieldWrapper(BaseCheckboxGroup_);
export default BaseCheckboxGroup;
